import React from 'react';
import PropTypes from 'prop-types';
import Svg, { G, Path } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function EmailIcon(props) {
  const {
    color,
    ...svgProps
  } = props;

  return (
    <Svg
      {...svgProps}
      viewBox="0 0 34 34"
    >
      <G fill={color} fillRule="evenodd">
        <Path
          d="M17 33.5c9.113 0 16.5-7.387 16.5
          -16.5S26.113.5 17 .5.5 7.887.5 17 7.887 33.5 17 33.5zm0
          -1C8.44 32.5 1.5 25.56 1.5 17 1.5 8.44 8.44 1.5 17 1.5c8.56 0 15.5 6.94 15.5 15.5 0 8.56
          -6.94 15.5-15.5 15.5z"
        />
        <Path
          d="M9.125 11.375c-.463 0-.844.38-.844.844v9.56c0 .464.382.845.845.845h15.75c.463 0
          .844-.38.844-.844v-9.56c0-.464-.382-.845-.845-.845H9.125zm.21.563h15.33L17 18.59 9.336
          11.94zm-.49.316l7.97 6.926c.106.092.264.092.37 0l7.97-6.926v9.527c0 .162-.12.283
          -.28.283H9.125c-.16 0-.28-.12-.28-.282v-9.526z"
          stroke={color}
          strokeWidth=".2"
        />
      </G>
    </Svg>
  );
}

EmailIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

EmailIcon.defaultProps = {
  height: 21,
  width: 32,
};

export default pure(EmailIcon);
